import React, { useState } from 'react';
import { IonContent, IonLabel, IonSegment, IonSegmentButton, IonToolbar, SegmentChangeEventDetail } from '@ionic/react';
import Orders from './Orders';
import { IonSegmentCustomEvent } from '@ionic/core/dist/types/components';
import { useGetOrderHistoryQuery } from '../../../../../../../store/api-slices';
import { OrderFulfillmentScope } from '../../../../../../../services/exports/Constants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../../../../store/types';

const SEGMENTS = [
  {
    value: OrderFulfillmentScope.Active,
    label: 'active',
  },
  {
    value: OrderFulfillmentScope.Complete,
    label: 'completed',
  },
  {
    value: OrderFulfillmentScope.Cancelled,
    label: 'cancelled',
  },
] as const;

const OrdersContent = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Orders:Components:OrdersContent' });

  const { franchise } = useSelector((state: StoreInterface) => state.initialData);
  const [fulfilmentStatus, setFulfilmentStatus] = useState(OrderFulfillmentScope.Active);
  const { data } = useGetOrderHistoryQuery({
    filter: {
      [fulfilmentStatus]: true,
      franchise_id: franchise?.id,
    },
  });

  const onSegmentChange = (e: IonSegmentCustomEvent<SegmentChangeEventDetail>): void => {
    setFulfilmentStatus(e.detail.value as OrderFulfillmentScope);
  };

  return (
    <>
      <IonToolbar className="ion-color !min-h-fit [&::part(container)]:min-h-fit [&::part(container)]:py-sm">
        <IonSegment value={fulfilmentStatus} className="bg-white space-x-md" onIonChange={onSegmentChange}>
          {SEGMENTS.map(({ value, label }) => (
            <IonSegmentButton
              key={value}
              value={value}
              className="font-semibold text-sm py-[6px] [&::part(indicator-background)]:bg-brand-primary [&::part(indicator-background)]:rounded-[37px] text-muted-foreground [&.segment-button-checked]:text-white"
            >
              <IonLabel>{t(`segment_labels.${label}`)}</IonLabel>
            </IonSegmentButton>
          ))}
        </IonSegment>
      </IonToolbar>
      <IonContent className="[&::part(scroll)]:px-4 [&::part(scroll)]:py-lg space-y-4">
        <Orders data={data?.data} />
      </IonContent>
    </>
  );
};

export default OrdersContent;
